import { render, staticRenderFns } from "./ApprovalBOD.vue?vue&type=template&id=5d8a4b66&scoped=true&lang=pug"
import script from "./ApprovalBOD.vue?vue&type=script&lang=js"
export * from "./ApprovalBOD.vue?vue&type=script&lang=js"
import style0 from "./ApprovalBOD.vue?vue&type=style&index=0&id=5d8a4b66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a4b66",
  null
  
)

export default component.exports